import { types, actions } from './requests'
export const DELETEJOB_TYPES = {
    ...types('DELETEJOB'),
}
export const DELETEJOB_ACTIONS = {
    ...actions('DELETEJOB'),
}
